<div class="modal-content">
  <div class="modal-header">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick()" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <h4 class="modal-title" data-cy="transportOrderRefundDialogHeading" jhiTranslate="refundTransport.title" [translateValues]="{ ot: transport.id }"></h4>
  </div>

  <div class="d-flex flex-row align-items-center my-3 text-center">
    <div class="flex-grow-1">
      <strong class="mr-2" jhiTranslate="refundTransport.modePaiement"></strong>
      <strong>{{ transport.paymentMethod }}</strong>
    </div>
    <div class="flex-grow-1">
      <strong jhiTranslate="refundTransport.status"></strong>
      <jhi-bary-badge [options]="transport.statusBadgeOpts()"></jhi-bary-badge>
    </div>
    <div class="flex-grow-1">
      <strong>{{ 'MODAL_REFUND_BILL.SUBTITLE.DATE' | translate }}&nbsp;:</strong>
      <span>{{ transport.creationDate?.toDate() | date: 'dd/MM/yy' }}</span>
    </div>
  </div>
  <jhi-transport-card class="mx-4 d-block" [transport]="transport"></jhi-transport-card>

  <div class="d-flex flex-row mx-auto" *ngIf="form">
    <form class="d-flex flex-column mx-2 px-4">
      <jhi-bary-input-price
        [control]="form.get('refundAmount')! | asFormControl"
        [min]="0"
        [max]="getMaximumRefundable()"
        [label]="'MODAL_REFUND_BILL.REFUND_AMOUNT' | translate"
        class="mx-2 input-form"
      >
      </jhi-bary-input-price>
      <jhi-bary-input-select
        class="d-block input-form mx-2"
        id="input-select-opt"
        [placeholder]="emptyMotif"
        [label]="'LABEL.REASON' | translate"
        [control]="form.get('reason')! | asFormControl"
        [options]="option"
      ></jhi-bary-input-select>
      <jhi-bary-input-text [label]="'LABEL.CONTRACTOR' | translate" class="mx-2" [control]="form.get('contractor')! | asFormControl"></jhi-bary-input-text>
    </form>
    <div class="d-flex flex-row my-3 px-4 flex-grow-1">
      <div class="flex-grow-1">
        <jhi-cart-group-value
          label="{{ 'LABEL.TOTAL_PRE_TAXES_PRICE' | translate }}"
          [items]="getBillHTItems()"
          [value]="getTransportPriceHTWithGazoleTax() | currency: 'EUR'"
        ></jhi-cart-group-value>
        <jhi-cart-value [label]="'LABEL.VAT_DEFAULT' | translate" [value]="getTransportVAT() | currency: 'EUR'"></jhi-cart-value>
        <jhi-cart-value [label]="'LABEL.TOTAL_FULL_TAXES_PRICE' | translate" [value]="getTransportTTC() | currency: 'EUR'" [color]="'bold color-dark'"></jhi-cart-value>
        <hr class="mt-0" *ngIf="(transport.refundAmount || 0) > 0" />
        <jhi-cart-value
          *ngIf="(transport.refundAmount || 0) > 0"
          [suffix]="'SUFFIX.FULL_TAXES' | translate"
          [label]="'LABEL.ALREADY_REFUND' | translate"
          [value]="-getAlreadyRefundTTC() | currency: 'EUR'"
        ></jhi-cart-value>
        <hr class="mt-0" />
        <jhi-cart-value [label]="'MODAL_REFUND_BILL.SUB_BLOCK.PRICE_HT_TO_REFUND' | translate" [value]="getRefundHT() | currency: 'EUR'" [color]="'text-danger'"></jhi-cart-value>
        <jhi-cart-value [label]="'MODAL_REFUND_BILL.SUB_BLOCK.PRICE_VAT_TO_REFUND' | translate" [value]="getRefundVat() | currency: 'EUR'" [color]="'text-danger'"></jhi-cart-value>
        <jhi-cart-value
          [label]="'MODAL_REFUND_BILL.SUB_BLOCK.PRICE_TTC_TO_REFUND' | translate"
          [value]="getRefundTTC() | currency: 'EUR'"
          [color]="'text-danger bold'"
        ></jhi-cart-value>
      </div>
    </div>
  </div>
  <div class="mx-2 text-center my-3">
    <jhi-bary-input-checkbox [control]="acceptAllRefunds" [label]="'MODAL_REFUND_BILL.SUB_BLOCK.CHECKBOX_TRANSPORT' | translate"></jhi-bary-input-checkbox>
  </div>
  <div class="modal-footer justify-content-center" *ngIf="form">
    <jhi-bary-button (clickEvent)="handleSubmit()" [label]="'BTN.SUBMIT' | translate" color="primary" [disabled]="!acceptAllRefunds.value"></jhi-bary-button>
  </div>
</div>
